import * as React from "react";
const SvgFiRrFaceGlasses = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-glasses_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m5 8h2c1.103 0 2 .897 2 2s-.897 2-2 2h-2c-1.103 0-2-.897-2-2s.897-2 2-2m-5-6c3.341 0 6.296 1.653 8.113 4.177A4 4 0 0 0 19 6h-2c-1.474 0-2.75.81-3.444 2h-3.112C9.75 6.81 8.474 6 7 6H5c-.389 0-.758.073-1.113.177C5.704 3.653 8.66 2 12 2M5 8h2c1.103 0 2 .897 2 2s-.897 2-2 2H5c-1.103 0-2-.897-2-2s.897-2 2-2m7 14c-5.291 0-9.625-4.135-9.967-9.342A3.98 3.98 0 0 0 5 14h2c2.206 0 4-1.794 4-4h2c0 2.206 1.794 4 4 4h2a3.98 3.98 0 0 0 2.967-1.342C21.625 17.865 17.292 22 12 22m4.847-5.531a1 1 0 0 1-.315 1.378C15.364 18.58 13.713 19 12.001 19c-1.606 0-3.472-.565-4.483-1.125a1 1 0 0 1 .966-1.75c.763.421 2.323.875 3.517.875 1.562 0 2.815-.438 3.469-.847a.996.996 0 0 1 1.378.315zM16.5 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-11 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-glasses_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceGlasses;
